import { useState } from 'react';
import { Button, ButtonProps } from '@/components/ui/button';
import { useStripe } from '@/hooks/useStripe';
import { useToast } from '@/hooks/use-toast';
import { LoaderCircle, Settings } from 'lucide-react';

interface ManageSubscriptionButtonProps extends Omit<ButtonProps, 'onClick'> {
  children?: React.ReactNode;
}

export function ManageSubscriptionButton({
  children,
  disabled,
  ...props
}: ManageSubscriptionButtonProps) {
  const { openBillingPortal, loading } = useStripe();
  const { toast } = useToast();
  const [isRedirecting, setIsRedirecting] = useState(false);

  const handleClick = async () => {
    try {
      setIsRedirecting(true);
      await openBillingPortal();
    } catch (error) {
      setIsRedirecting(false);
      toast({
        variant: 'destructive',
        title: 'Erro ao abrir portal',
        description: 'Não foi possível abrir o portal de assinatura. Tente novamente.',
      });
    }
  };

  const isLoading = loading || isRedirecting;

  return (
    <Button
      onClick={handleClick}
      disabled={disabled || isLoading}
      variant="outline"
      {...props}
    >
      {isLoading ? (
        <>
          <LoaderCircle className="h-5 w-5 animate-spin" />
          Abrindo...
        </>
      ) : (
        <>
          <Settings className="h-4 w-4 mr-2" />
          {children || 'Gerenciar assinatura'}
        </>
      )}
    </Button>
  );
}
